import React, { useEffect, useState } from 'react';
import {
  Base,
  Container,
  Footer,
  Groove,
  Odometer,
  Score,
  Speedbox,
  SpeedometerContainer,
  Wrapper,
} from './styles';
import { CaretDown, Chats, Exam, Play } from 'phosphor-react';

import api from '../../services/api';

export interface IEstudometroProps {
  daysStudied: number;
  watchedClasses: number;
  answeredQuestions: number;
  answeredTopics: number;
  practicesDone: number;
}


const CardEstudometro: React.FC = () => {

  const [estudometroData, setEstudometroData] = useState<IEstudometroProps>({} as IEstudometroProps);

  const currentYear = new Date().getFullYear();
  const [currentMonth, setCurrentMonth] = useState<number>(new Date().getMonth() + 1);
  const [daysInMonth, setDaysInMonth] = useState<number>(new Date(currentYear, currentMonth, 0).getDate());

  const daysStudied = estudometroData?.daysStudied || 0;

  const studyPercentage = (daysStudied / daysInMonth) * 100;

  const rotation = Math.round((studyPercentage * 180) / 100) - 45;

  useEffect(() => {
    setDaysInMonth(new Date(currentYear, currentMonth, 0).getDate());
  }, [currentMonth, currentYear]);

  // Função para obter o nome do mês por extenso
  const getMonthName = (month: number) => {
    return new Date(currentYear, month - 1, 1).toLocaleString("pt-BR", { month: "long" });
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await api.get('/estudometro', {
          params: {
            month: currentMonth
          },
        });

        setEstudometroData(response.data);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [currentMonth]);

  return (
    <>
      <Wrapper>
        <header>
          <aside>
            <h5>Estudômetro</h5>
            <h6>Seu progresso de estudos no mês</h6>
          </aside>
          <div>
            <select
              name="month"
              id="month"
              onChange={(e) => setCurrentMonth(Number(e.target.value))}
              defaultValue={currentMonth}
            >
              {/* Mapeando os meses do ano */}
              {Array.from({ length: 12 }).map((_, index) => (
                index <= new Date().getMonth() &&
                  <option key={index + 1} value={index + 1}>
                  {getMonthName(index + 1)}
                </option>
              ))}
            </select>
            <CaretDown weight="duotone" />
          </div>
        </header>
        <Container>
            <>
              <main>
                <SpeedometerContainer>
                  <Speedbox>
                    <Score rotation={rotation} />
                    <Groove />
                    <Odometer>
                      <h1>{(daysStudied > 0 &&  daysStudied <= 9) ? `0${daysStudied}` : daysStudied}/{daysInMonth}</h1>
                      <h6>em {getMonthName(currentMonth)} você estudou {daysStudied} de {daysInMonth} dias</h6>
                    </Odometer>
                    <Base />
                  </Speedbox>
                </SpeedometerContainer>
              </main>
            </>
          <Footer>
            <div>
              <aside>
                <aside>
                  <div>
                    <Play size={28} weight='duotone' />
                  </div>
                </aside>
                <main>
                  <h6>{currentMonth === new Date().getMonth() + 1 ? 'Este mês' : `Em ${getMonthName(currentMonth)}`}</h6>
                  <h3>Aulas assistidas</h3>
                </main>
              </aside>
              <footer>
                <h5>{estudometroData?.watchedClasses}</h5>
              </footer>
            </div>

            <div>
              <aside>
                <aside>
                  <div>
                    <Exam size={28} weight='duotone' />
                  </div>
                </aside>
                <main>
                  <h6>{currentMonth === new Date().getMonth() + 1 ? 'Este mês' : `Em ${getMonthName(currentMonth)}`}</h6>
                  <h3>Exercícios resolvidos</h3>
                </main>
              </aside>
              <footer>
                <h5>{estudometroData?.answeredQuestions}</h5>
              </footer>
            </div>
            
            <div>
              <aside>
                <aside>
                  <div>
                    <Chats size={28} weight='duotone' />
                  </div>
                </aside>
                <main>
                  <h6>{currentMonth === new Date().getMonth() + 1 ? 'Este mês' : `Em ${getMonthName(currentMonth)}`}</h6>
                  <h3>Tópicos respondidos</h3>
                </main>
              </aside>
              <footer>
                <h5>{estudometroData?.answeredTopics}</h5>
              </footer>
            </div>
            
            <div>
              <aside>
                <aside>
                  <div>
                    <Exam size={28} weight='duotone' />
                  </div>
                </aside>
                <main>
                  <h6>{currentMonth === new Date().getMonth() + 1 ? 'Este mês' : `Em ${getMonthName(currentMonth)}`}</h6>
                  <h3>Simulados realizados</h3>
                </main>
              </aside>
              <footer>
                <h5>{estudometroData?.practicesDone}</h5>
              </footer>
            </div>
          </Footer>
        </Container>
      </Wrapper>
    </>
  );
};

export default CardEstudometro;
